import { IAjaxConfig } from '../libraries';
/**
 *  微信 API 地址
 *  @swagger  https://tst-bpcentral.lenovo.com.cn/wechat/swagger-ui.html#/%E5%BE%AE%E4%BF%A1%E6%8E%88%E6%9D%83%E7%B1%BB%E6%8E%A5%E5%8F%A3
 */
export class EnumApiWechat {
  /**
   * @dec 临时接口，重定向到微信oauth认证，无需传递x-app-id请求头
   */
  readonly wechat_redirect: IAjaxConfig = {
    url: '/api/bpportal/bp-customer-wechat-svr/auth/oauth/url/redirect',
  };

  /**
   * @dec 登录微信
   */
  readonly wechat_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 绑定用户微信
   */
  readonly wechat_bind_user: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/user/mobile/bind',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 提交授权，rel和isg
   */
  readonly wechat_authorize: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/oauth2/authorize',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 轮询检查微信登陆
   */
  readonly wechat_check_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/check/login',
    method: 'get',
    loading: false,
    awaitAuthenticated: false,
  };

  /**
   * @dec 获取微信扫码标识
   */
  readonly wechat_get_requestId: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/requestId/get',
    method: 'get',
    loading: false,
    awaitAuthenticated: false,
  };

  /**
   * @dec 绑定微信号
   */
  readonly wechat_bind: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/bind',
    method: 'post',
    awaitAuthenticated: false,
  };

  /**
   * @dec 解除绑定微信号
   */
  readonly wechat_relieve_bind: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/relieve/bind',
    method: 'post',
    awaitAuthenticated: false,
  };

  /**
   * @dec 轮询检查微信绑定
   */
  readonly wechat_check_bind: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/check/bind',
    method: 'get',
    loading: false,
    awaitAuthenticated: false,
  };

  /**
   * @dec 根据idToken获取微信id
   */
  readonly wechat_get_id: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/user/get',
    method: 'get',
    awaitAuthenticated: false,
  };
  /**
   * @dec 保存微信扩展信息
   */
  readonly wechat_extend_save: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/extend/save',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 生成jsap权限签名
   */
  readonly wechat_jsapi_sign: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-customer-bffsvr/wechat/auth/jsapi/sign',
    method: 'post',
    // loading: true
    // cache: true
  };
  /**
   * @dec 获取小程序 openid
   * @body jsCode
   */
  readonly wechat_weapp_session: IAjaxConfig = {
    url: '/api/bpportal/bp-customer-wechat-svr/mini/user/session/get',
  };

  /**
   * @dec 获取 openid
   */
  readonly wechat_info: IAjaxConfig = {
    url: '/wechat/user/info/get',
    loading: true,
  };
  /**
   * @dec 发送模板消息
   */
  readonly wechat_send: IAjaxConfig = {
    url: '/wechat/msg/subscribe/send',
    method: 'post',
    loading: true,
  };
}
